import { render, staticRenderFns } from "./BlackListConfig.vue?vue&type=template&id=0ccea661&scoped=true&"
import script from "./BlackListConfig.vue?vue&type=script&lang=js&"
export * from "./BlackListConfig.vue?vue&type=script&lang=js&"
import style0 from "./BlackListConfig.vue?vue&type=style&index=0&id=0ccea661&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccea661",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VForm,
  VSwitch,
  VTextField,
})
